import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useAdminPWA = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    // Only register service worker on admin routes
    if (!isAdminRoute) {
      return;
    }

    // Check if service worker is supported
    if ('serviceWorker' in navigator) {
      // Register service worker for admin PWA
      navigator.serviceWorker
        .register('/sw.js', { scope: '/' })
        .then((registration) => {
          console.log('Admin PWA Service Worker registered:', registration);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    }

    // Handle PWA install prompt (only on admin routes)
    let deferredPrompt: any;

    const handleBeforeInstallPrompt = (e: Event) => {
      console.log('[Admin PWA] Install prompt available');
      e.preventDefault();
      deferredPrompt = e;
    };

    const handleAppInstalled = () => {
      console.log('[Admin PWA] Installed successfully');
      deferredPrompt = null;
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, [isAdminRoute]);
};
